import React, { memo } from 'react';
import './people.scss';
import Culture from '../../components/likelihoodPannel';
import Choices, {
  // EulerChartWithChoices,
  ChoicesWithTooltips,
} from '../../components/choices';

const comp = {
  8: Choices,
  9: Culture,
  10: ChoicesWithTooltips,
};
function People(props) {
  const Content = props.c;
  return (
    <Content
      {...props}
      comp={comp}
      compLocation="down"
      showSubSection={false}
      showContentAsSubtitle
    />
  );
}

export default memo(People);
